<div class="modal-body">
  <ul>
    <li class="p-ul"><strong class="text-strong">Habilidades</strong></li>
    <li *ngFor="let item of this.itemObj.listAttributes">{{item.name}}</li>
  </ul>
  <ul>
    <li class="p-ul"><strong class="text-strong">Atitudes</strong></li>
    <li *ngFor="let item of this.itemObj.listSkills">{{item.name}}</li>
  </ul>
</div>